/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type LastInteractionTagFilterConfigColumn =
  (typeof LastInteractionTagFilterConfigColumn)[keyof typeof LastInteractionTagFilterConfigColumn];

export const LastInteractionTagFilterConfigColumn = {
  last_interaction_tag: 'last_interaction_tag',
} as const;
